import React, { useEffect, useState } from 'react';
import './Loading.css';

import logo from '../../assets/images/amtex_logo.png';

function Loading() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const logos =  [logo];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === logos.length - 1 ? 0 : prevIndex + 1
      );
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="loading-overlay">
      <div className="loading-container">
        <div className="rotating-ring"></div>
        <img
          key={currentIndex}
          src={logos[currentIndex]}
          alt="Logo"
          className="logo-image fade-slide"
        />
      </div>
    </div>
  );
}

export default Loading;